var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import * as _ from "lodash";
import * as query from "query-string";
import logger from "./logging/Logger.js";
import navigationService from "./NavigationService.js";
import { c as compareIgnoreCase } from "../CommonStringUtils-1580a6f6.js";
const DO_NOT_REDIRECT = "__doNotRedirect";
const DO_NOT_REDIRECT_DRI_ONLY = "__doNotRedirectDriOnly";
class OptInService {
  constructor(localStorageForTest) {
    // create a map
    // look at local storage to check with experience
    // add/remove from local storage
    // do we redirect?
    // what message do we show?
    // map of routes (i.e.) /:stepId/(study)?/:studyId?/(task)?/:taskId?
    __publicField(this, "optInExperienceConfigs", []);
    __publicField(this, "_provideLocalStorage");
    __publicField(this, "_mapByPath");
    __publicField(this, "mapUnique", (source, map, message, property) => {
      _.each(source, (c) => {
        const prop = c[property];
        if (!prop) {
          throw `property ${property} does not exist on ${JSON.stringify(c, null, 2)}`;
        }
        if (map[prop.toLowerCase()]) {
          throw `{message}.  '${prop}' already exists`;
        } else {
          map[prop.toLowerCase()] = c;
        }
      });
    });
    const notDefined = (name) => {
      throw `${name} undefined for local test implementation`;
    };
    this._provideLocalStorage = localStorageForTest ? __spreadValues({
      clear: () => notDefined("clear"),
      getItem: (key) => notDefined("getItem"),
      key: (index) => notDefined("key"),
      removeItem: (key) => notDefined("removeItem"),
      setItem: (key, value) => notDefined("setItem"),
      length: 0
    }, localStorageForTest) : localStorage;
    this.mapUnique(this.optInExperienceConfigs, {}, "key must be unique", "newPath");
    this._mapByPath = {};
  }
  config(config) {
    this.optInExperienceConfigs = config;
    this.mapPaths();
  }
  mapPaths() {
    this.mapUnique(this.optInExperienceConfigs, this._mapByPath, "path (old and new) must be unique", "oldPath");
    this.mapUnique(this.optInExperienceConfigs, this._mapByPath, "path (old and new) must be unique", "newPath");
  }
  getLowerCaseMap(map) {
    let lowerCaseMap = {};
    _.each(map, (val, name) => {
      lowerCaseMap[name.toLowerCase()] = val;
    });
    return lowerCaseMap;
  }
  // note the map must have lowercase keys
  getFromMapCaseInsensitive(map, key) {
    return map[key.toLowerCase()];
  }
  getLocalStoreKey(key) {
    return `__expOptInExperience:${key}`;
  }
  isNewPath(path, configForPath) {
    const isNewPath = path.toLowerCase() == configForPath.newPath.toLowerCase();
    return isNewPath;
  }
  getLocalStoreValue(config) {
    const localStoreValue = this._provideLocalStorage.getItem(this.getLocalStoreKey(config.key));
    return localStoreValue === "true" ? true : localStoreValue === "false" ? false : null;
  }
  // given an oldPath, we either redirect (using the oldUrl and mapping),
  // or return null (do nothing)
  // We only ever redirect from old url => new url (new => old is an explict navigate by the user)
  redirect(match, location) {
    const oldPath = (match.path || "").toLowerCase();
    const params = match.params || {};
    let searchObj = query.parse(location.search || "");
    let redirectTo = null;
    const configForPath = this._mapByPath[oldPath];
    const doNotRedirect = configForPath && !configForPath.hideLegacyLink() && !!searchObj[DO_NOT_REDIRECT];
    const doNotRedirectDriOnly = !!searchObj[DO_NOT_REDIRECT_DRI_ONLY];
    const newExperienceDefaultFromStore = configForPath && this.getLocalStoreValue(configForPath);
    const forceNewExperienceAsDefault = configForPath && configForPath.forceNewExperienceAsDefault();
    if (!doNotRedirect && !doNotRedirectDriOnly && configForPath && compareIgnoreCase(oldPath, configForPath.oldPath) && (newExperienceDefaultFromStore || forceNewExperienceAsDefault)) {
      redirectTo = configForPath.mapToNewUrl(
        (key) => this.getFromMapCaseInsensitive(this.getLowerCaseMap(params), key),
        (key) => this.getFromMapCaseInsensitive(this.getLowerCaseMap(searchObj), key)
      );
    }
    if (configForPath) {
      logger.trackMetric({
        name: "OptInService:Redirect",
        average: !!redirectTo ? 1 : 0,
        properties: {
          doNotRedirect,
          doNotRedirectDriOnly,
          oldPath,
          configForPathKey: configForPath.key,
          redirectTo,
          newExperienceDefaultFromStore,
          forceNewExperienceAsDefault
        }
      });
    }
    return redirectTo;
  }
  // this is really a private function, but make public for testing
  static addQueryStringParam(url, addParam) {
    const findQs = url.indexOf("?");
    let path = url;
    let qsParts = [];
    if (findQs != -1) {
      path = url.substring(0, findQs);
      const qs = url.substring(findQs + 1);
      qsParts = _.map(query.parse(qs), (val, name) => `${name}=${val}`);
    }
    qsParts.push(addParam);
    return `${path}?${qsParts.join("&")}`;
  }
  // if null is returned, this route is not configured for an optInOut expericend
  // else return the config the message box to determin message and link (link to new, old, etc)
  getExperience(match, location) {
    const path = (match.path || "").toLowerCase();
    const params = match.params || {};
    let searchObj = query.parse(location.search || "");
    const configForPath = this._mapByPath[path];
    const doNotRedirect = !(configForPath == null ? void 0 : configForPath.hideLegacyLink()) && !!searchObj[DO_NOT_REDIRECT];
    const doNotRedirectDriOnly = !!searchObj[DO_NOT_REDIRECT_DRI_ONLY];
    if (!configForPath) {
      return null;
    } else {
      const isNewPath = this.isNewPath(path, configForPath);
      const forceNewExperienceAsDefault = configForPath.forceNewExperienceAsDefault();
      const newExperienceDefaultFromStore = this.getLocalStoreValue(configForPath);
      const showOptIn = configForPath.show();
      const configForPathKey = configForPath.key;
      let optInExperience = null;
      const isNewExperienceDefault = forceNewExperienceAsDefault ? true : newExperienceDefaultFromStore;
      const hideLegacyLink = configForPath.hideLegacyLink();
      const hide = configForPath.hide();
      if (forceNewExperienceAsDefault || showOptIn || newExperienceDefaultFromStore !== null) {
        const linkFunc = isNewPath ? configForPath.mapToOldUrl : configForPath.mapToNewUrl;
        let link = linkFunc(
          (key) => this.getFromMapCaseInsensitive(this.getLowerCaseMap(params), key),
          (key) => this.getFromMapCaseInsensitive(this.getLowerCaseMap(searchObj), key)
        );
        if (isNewPath && isNewExperienceDefault) {
          link = OptInService.addQueryStringParam(link, `${DO_NOT_REDIRECT}=1`);
        }
        const helpLinkProps = isNewPath ? configForPath.helpLinkProps : null;
        optInExperience = {
          configForPathKey,
          linkMessage: `${!isNewPath ? "Try the new" : "Go back to the legacy"} ${configForPath.displayName} experience`,
          isNewExperience: isNewPath,
          helpLinkProps,
          link,
          isNewExperienceDefault,
          warnUserOfForceDefault: configForPath.warnUserOfForceDefault(),
          forceNewExperienceAsDefault,
          hideLegacyLink,
          hide
        };
      }
      logger.trackMetric({
        name: "OptInService:Experience",
        average: !!optInExperience ? 1 : 0,
        properties: {
          isNewPath,
          path,
          configForPathKey,
          doNotRedirect,
          doNotRedirectDriOnly,
          isNewExperienceDefault: !!isNewExperienceDefault,
          newExperienceDefaultFromStore,
          forceNewExperienceAsDefault,
          hideLegacyLink,
          hide
        }
      });
      return optInExperience;
    }
  }
  setNewExperienceAsDefault(rawPath, setNewExperienceAsDefault) {
    const path = rawPath.toLowerCase();
    const configForPath = this._mapByPath[path];
    if (!configForPath) {
      throw new Error(`config not found for ${path}`);
    }
    const newExperienceDefaultFromStore = this.getLocalStoreValue(configForPath);
    const isNewPath = this.isNewPath(path, configForPath);
    logger.trackMetric({
      name: "OptInService:SetAsDefault",
      average: setNewExperienceAsDefault ? 1 : 0,
      properties: {
        isNewPath,
        path,
        configForPathKey: configForPath.key,
        setNewExperienceAsDefault,
        newExperienceDefaultFromStore
      }
    });
    this._provideLocalStorage.setItem(this.getLocalStoreKey(configForPath.key), setNewExperienceAsDefault.toString());
  }
  isDoNotRedirectParamPresent(locationSearch = window.location.search) {
    const parameter = navigationService.getUrlParam(DO_NOT_REDIRECT, locationSearch) || navigationService.getUrlParam(DO_NOT_REDIRECT_DRI_ONLY, locationSearch);
    return parameter === "1";
  }
}
const OptInService$1 = new OptInService();
export {
  DO_NOT_REDIRECT,
  DO_NOT_REDIRECT_DRI_ONLY,
  OptInService,
  OptInService$1 as default
};
//# sourceMappingURL=OptInService.js.map
